import { isNullOrUndefined } from '@as-react/common-utils';
import { Target } from 'redux-beacon';
import { Options } from './types';

declare const window: Window & {
  dataLayer: Array<Record<string, unknown>>;
};

const GoogleTagManager =
  (options: Options = {}): Target =>
  events => {
    const dataLayerName = (options.dataLayerName || 'dataLayer') as keyof typeof window;

    if (typeof window === 'undefined') {
      return;
    }

    if (!window[dataLayerName] || typeof window[dataLayerName].push !== 'function') {
      console.warn(
        `redux-beacon error: window.${dataLayerName} is not defined. Have you forgotten to include Google Tag Manager and dataLayer?`
      );
      return;
    }

    events.forEach(event => {
      if (!isNullOrUndefined(event)) {
        const eventToPush = (() => {
          if (event.event === undefined && event.hitType !== undefined) {
            return Object.assign({}, event, { event: event.hitType });
          }
          return event;
        })();

        window[dataLayerName].push(eventToPush);
      }
    });
  };

export default GoogleTagManager;
